import React, {useEffect, useRef, useState} from 'react';
import styles from './SearchBar.module.css';
import SearchWithAiButton from "../SearchWithAiButton/SearchWithAiButton";
import NobiEventTracker from "../../utils/NobiEventTracker";
import Events from "../../utils/Events";
import {EntryPoint} from "../Chatbot/EntryPoint";

const SearchBar = ({ merchantId, onSearchSubmitted, onQueryUpdated, brandTheme, isDrawerOpen, isSearchBarVisible, onClickOutside, searchIconSelector }) => {
    const [query, setQuery] = useState('');
    const inputRef = useRef(null);
    const [wasChatbotPreloaded, setWasChatbotPreloaded] = useState(false);

    const formRef = useRef(null);

    const preloadChatbot = () => {
        if (wasChatbotPreloaded) {
            return;
        }
        import('../Chatbot/Chatbot');
        setWasChatbotPreloaded(true);
    };

    useEffect(() => {
        if (inputRef.current && !isDrawerOpen) {
            inputRef.current.focus();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isDrawerOpen && inputRef.current && isSearchBarVisible) {
            inputRef.current.focus();
        }
    }, [isDrawerOpen, isSearchBarVisible]);

    // Need to register the click outside handler to close the search bar
    useEffect(() => {
        if (isDrawerOpen) {
            return;
        }

        const handleClickOutside = (event) => {
            if (searchIconSelector && event.target.closest(searchIconSelector)) {
                return; // Ignore clicks on the search icon
            }

            if (formRef.current && !formRef.current.contains(event.target)) {
                onClickOutside?.();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClickOutside, isDrawerOpen, searchIconSelector]);

    function startSearch() {
        NobiEventTracker.trackEvent(
            merchantId,
            {
                query: query,
                searchEngine: "Nobi"
            },
            EntryPoint.SearchBar,
            Events.Search);
        NobiEventTracker.trackEvent(
            merchantId,
            {query: query},
            EntryPoint.SearchBar,
            Events.SearchOnNobi);
        NobiEventTracker.trackEvent(
            merchantId,
            {query: query},
            EntryPoint.SearchBar,
            Events.SendMessage);
        onSearchSubmitted();
        setQuery('');
    }

    return (
        <form
            ref={formRef}
            onSubmit={(e) => {
                e.preventDefault();
                startSearch();
            }}
            id={"nobi-search-form"}
            className={styles.form}
            aria-label="Search Form"
        >
            <div className={styles.inputWrapper}>
                <input
                    ref={inputRef}
                    type="text"
                    placeholder="What are you looking for?"
                    value={query}
                    onChange={(e) => {
                        setQuery(e.target.value);
                        onQueryUpdated(e.target.value);
                        preloadChatbot();
                    }}
                    onFocus={preloadChatbot}
                    className={styles.input}
                    aria-label="Search Query"
                />
            </div>
            <SearchWithAiButton
                merchantId={merchantId}
                brandTheme={brandTheme}
                buttonLabel={"Search With AI"}
                onClick={startSearch}
                isSubmitForForm={true}
                entryPoint={EntryPoint.SearchBar} />
        </form>
    );
};

export default SearchBar;
